import React, { useEffect } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'
import TableRow from '@material-ui/core/TableRow'
import { juryoMobileSummaryTable } from 'assets/TableHeader'
import M_TableCell from 'components/1_Atoms/2_Molecules/M_TableCellHead'
import { organismLog } from 'utils/logUtil'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
    },
    table: {
      // backgroundColor: '#66FF99',
    },
    container: {
      maxHeight: 600,
    },
  }),
)

const width = juryoMobileSummaryTable.width
const label = juryoMobileSummaryTable.label

// type Props = {}

const O_TableHeaderJokenMobileSummary = () => {
  useEffect(() => organismLog('O_TableHeaderJokenMobileSummary'))
  const classes = useStyles()

  return (
    <TableRow className={classes.table}>
      {/* No */}
      {/* <M_TableCell category="number" data={'NO'} width={width.NO} /> */}
      {/* 受領区分 */}
      <M_TableCell category="data" width={width.JURYO_KBN} title={label.JURYO_KBN} data={label.JURYO_KBN} caption={false} />
      {/* 伝票日付 */}
      <M_TableCell category="data" width={width.NOHIN_YMD} title={label.NOHIN_YMD} data={label.NOHIN_YMD} caption={false} />
      {/* 得意先名 */}
      <M_TableCell category="data" width={width.TOKUI_NM} title={label.TOKUI_NM} data={label.TOKUI_NM} caption={false} />
      {/* 店名 */}
      <M_TableCell category="data" width={width.TEN_NM} title={label.TEN_NM} data={label.TEN_NM} caption={false} />
    </TableRow>
  )
}

export default React.memo(O_TableHeaderJokenMobileSummary)
